import 'core-js';
import 'whatwg-fetch';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import AppContainer from '@module/app/AppContainer';

import './app.scss';

ReactDOM.render(
    <AppContainer />,
    document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/app/index.tsx